module.exports = __webpack_public_path__ + "static/img/pro4.2.e328ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pro4.2.jpg
// module id = k4X2
// module chunks = 1